module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/dashboard/ActionLog.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>Action Log</h5>\n    </div>\n\n    <div class="js-action-log-content"></div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/dashboard/ActionLog.ejs
// module id = 1022
// module chunks = 1